<template>
<div v-if="current">
    <div class="panel">
        <confirmModal v-if="showConfirm" message="vous confirmez choisir ces compétences de base ? Vous ne pourrez plus les modifier par la suite" @confirm="publishUpgrades" @closeMessage="showConfirm = false"></confirmModal>
        <spinningModal v-if="showSpinner"></spinningModal>
        <messageModal v-if="showMessage" message="Les compétences de base ont été enregistrées" @closeMessage="goToDetail"></messageModal>
        <team-detail-header :actions="false" :team="current"></team-detail-header>
        <div class="panel-content panel-top">
            <div class="row columns">
                <div class="large-12">
                    <table>
                        <thead class="roster">
                            <tr>
                                <th width="10">N°</th>
                                <th width="150">Nom</th>
                                <th width="150">Position</th>
                                <th width="10">M</th>
                                <th width="10">F</th>
                                <th width="10">Ag</th>
                                <th width="10">Ar</th>
                                <th width="400">Compétences</th>
                                <th width="100">Simple</th>
                                <th width="100">Double</th>
                            </tr>
                        </thead>
                        <tbody class="roster">
                            <tr v-if="current" v-for="player in current.players">
                                <td class="number">{{player.num}}</td>
                                <td >{{player.name}}</td>
                                <td >{{player.ref_roster_line.position}}</td>
                                <td >{{player.M}}</td>
                                <td >{{player.F}}</td>
                                <td >{{player.Ag}}</td>
                                <td >{{player.Ar}}</td>
                                <td >
                                    <span v-for="skill in player.skills" >
                                            {{skill.name}},
                                    </span>
                                </td>
                                <td class="small-input">
                                    <select class="line-input" :id="player.id"
                                        v-bind:disabled="(maxSimpleSkillsReached || maxUpgradeReached || isDoubleChosen(player.id)) && !isSimpleChosen(player.id)"
                                        @change="simpleSelected($event)">
                                        <option value="0"></option>
                                        <option v-for="skill in getSkills(player.ref_roster_line.normal_skills)" :value="skill.id">{{skill.name}}</option>
                                    </select>
                                </td>
                                <td class="small-input">
                                    <select class="line-input" :id="player.id"
                                        v-bind:disabled="(maxDoubleSkillsReached || maxUpgradeReached || isSimpleChosen(player.id)) && !isDoubleChosen(player.id)"
                                        @change="doubleSelected($event)">
                                        <option value="0"></option>
                                        <option v-for="skill in getSkills(player.ref_roster_line.double_skills)" :value="skill.id">{{skill.name}}</option>
                                    </select>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row">
                <div class="large-3 columns">
                    <button class="light-grey-button">Annuler</button>
                </div>
                <div class="large-4 columns">
                    <button :disabled="!maxUpgradeReached" @click="showConfirm = true" class="">Valider ces compétences</button>
                </div>
            </div>
        </div>
    </div>
</div>
<div v-else>
  <spinner></spinner>
</div>
</template>

<script>
import store from '../../store/index.js'
import spinner from '../common/spinner.vue'
import messageModal from '../common/message-modal.vue'
import confirmModal from '../common/confirm-modal.vue'
import teamDetailHeader from './team-header/team-detail-header.vue'
import { mapGetters } from 'vuex'
import playerUpgrade from '../../api/player-upgrade.api'
import Vue from 'vue'
import spinningModal from '../common/spinning-modal.vue'

export default {
  name: 'teamBaseSkills',
  components: {
    spinner,
    teamDetailHeader,
    messageModal,
    confirmModal,
    spinningModal
  },
  props: {
    'id': Number
  },
  data () {
    return {
      showMessage: false,
      showConfirm: false,
      showSpinner: false,
      maxSimpleSkillsReached: false,
      maxDoubleSkillsReached: false,
      maxUpgradeReached: false,
      baseUpgrade: []
    }
  },
  computed:
  {
    ...mapGetters([
      'currentUser',
      'simpleSkills'
    ]),
    current: function () {
      return store.getters.fullDetailedTeam
    }
  },
  created () {
    store.dispatch('hideLeaguePanel')
    store.dispatch('deactivateFullSizePage')
    store.dispatch('getFullDetailedTeam', this.id.toString())
    store.dispatch('getSimpleSkillList', 'GAFMP')
  },
  destroyed () {
    store.dispatch('invalidateDetailedTeam')
  },
  methods: {
    goToDetail () {
      this.showMessage = false
      this.$router.push({name: 'TeamDetail', params: { id: this.id }})
    },
    getSkills (skillString) {
      var skillList = []
      skillString.split('').forEach(cat => {
        let sl = this.simpleSkills.filter(skill => { return skill.family === cat })
        sl.forEach(sk => {
          skillList.push(sk)
        })
      })
      return skillList
    },
    simpleSelected ($event) {
      let targetPlayer = $event.target.id
      // annulation d'un choix
      if ($event.target.value === '0') {
        this.removeUpgrade(parseInt(targetPlayer, 10))
      } else {
        let upg = this.createSimpleUpgrade($event.target.value, $event.target.id)
        this.addOrReplaceUpgrade(upg)
      }
    },
    doubleSelected ($event) {
      let targetPlayer = $event.target.id
      // annulation d'un choix
      if ($event.target.value === '0') {
        this.removeUpgrade(parseInt(targetPlayer, 10))
      } else {
        let upg = this.createDoubleUpgrade($event.target.value, $event.target.id)
        this.addOrReplaceUpgrade(upg)
      }
    },
    addOrReplaceUpgrade (upgrade) {
      // on recherche dans la liste des upgrade voir si il existe un upgrade pour le joeur
      let index = this.baseUpgrade.findIndex(upg => { return upg.player === upgrade.player })
      if (index === -1) {
        // si on ne trouve pas, on ajoute brutalement
        Vue.set(this.baseUpgrade, this.baseUpgrade.length, upgrade)
        this.updateUpgradeCpt()
      } else {
        // sinon on remplace
        Vue.set(this.baseUpgrade, index, upgrade)
      }
    },
    removeUpgrade (playerId) {
      let index = this.baseUpgrade.findIndex(upg => { return upg.player === playerId })
      this.baseUpgrade.splice(index, 1)
      this.updateUpgradeCpt()
    },
    createSimpleUpgrade (skill, player) {
      let upgrade = {}
      upgrade.type = 0
      upgrade.value = 8
      upgrade.skill = parseInt(skill, 10)
      upgrade.status = 1
      upgrade.player = parseInt(player, 10)
      upgrade.match_id = null
      return upgrade
    },
    createDoubleUpgrade (skill, player) {
      let upgrade = {}
      upgrade.type = 0
      upgrade.value = 10
      upgrade.skill = parseInt(skill)
      upgrade.status = 1
      upgrade.player = parseInt(player)
      upgrade.match_id = null
      return upgrade
    },
    isSimpleChosen (playerId) {
      let found = this.baseUpgrade.findIndex(upg => { return upg.player === parseInt(playerId, 10) && upg.value === 8 })
      if (found === -1) {
        return false
      } else {
        return true
      }
    },
    isDoubleChosen (playerId) {
      let found = this.baseUpgrade.findIndex(upg => { return upg.player === parseInt(playerId, 10) && upg.value === 10 })
      if (found === -1) {
        return false
      } else {
        return true
      }
    },
    updateUpgradeCpt () {
      // on met à jour le compte des upgrades
      let simpleCpt = this.baseUpgrade.filter(upg => { return upg.value === 8 }).length
      let doubleCpt = this.baseUpgrade.filter(upg => { return upg.value === 10 }).length
      if (simpleCpt === 3) {
        this.maxSimpleSkillsReached = true
      } else {
        this.maxSimpleSkillsReached = false
      }
      if (doubleCpt === 1) {
        this.maxDoubleSkillsReached = true
      } else {
        this.maxDoubleSkillsReached = false
      }
      if ((doubleCpt + simpleCpt) === 3) {
        this.maxUpgradeReached = true
      } else {
        this.maxUpgradeReached = false
      }
    },
    publishUpgrades () {
      this.showConfirm = false
      this.showSpinner = true
      playerUpgrade.api.bulkPublishBaseUpgrade(this.baseUpgrade)
      .then(response => {
        this.showMessage = true
        this.showSpinner = false
        this.createdTeamId = response.data['id']
      },
      error => {
        console.log('erreur impossible to create team')
        console.log(error)
        this.showSpinner = false
      })
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.roster{
    font-weight: 300;
}

.roster tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.roster tr:nth-of-type(even) {
    background-color: #ffffff;
}

/***** gestion des formats de cellules*/

thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.8rem;
}

.roster tr td{
    padding: 0.5rem 0.2rem;
    text-align: center;
    font-size:0.7rem;
}

.roster tr td.sous-total{
    font-weight: 400;
    padding: 0.4rem 0rem;
}


.roster tr td.sous-total.right{

}

button.row{
    margin-left: 0.4rem;
}

.team-score {
    font-size: 2rem;
    font-weight: 450;
    padding-top: 1rem;
    padding-bottom: 0.2rem;
    padding-left: 0.2rem;
}

.match-result {
    font-size: 1.2rem;
    font-weight: 200;
    padding-bottom: 0.2rem;
    padding-left: 0.2rem;
}

.match-team-name {
    font-size: 1.7rem;
    font-weight: 300;
    padding-top: 1rem;
    padding-bottom: 0.2rem;
    padding-left: 0.2rem;
}

.panel-top {
    padding-top: 0rem;
}

.miss {
    text-decoration: line-through;
}

.skill-select {
    margin-bottom: 0
}

tr td input, tr td select{
    padding: 0.5rem 0.5rem;
    text-align: center;
    font-size:0.7rem;
    margin: 0rem;
}
</style>



// WEBPACK FOOTER //
// team-base-skills.vue?6a691add